import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  Image as CitrusImage,
  Text,
  withCitrusTheme,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'
import { getDefaultImage, getMoodImage, getSrcSet } from '../../../utils/formatters'

const Thumbnail = withCitrusTheme(CitrusImage, () => ({
  borderRadius: '2px',
  height: '32px',
  width: '32px',
}))

type UndoBannerProps = {
  recipe: Recipe
  onUndo: () => void
}

export const UndoBanner = ({ recipe, onUndo }: UndoBannerProps) => {
  const image = getMoodImage(recipe.images)

  return (
    <Box
      data-testid="undo-banner"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={3}
      paddingV={1}
      paddingH={1}
      paddingRight={3}
      borderRadius={1.5}
      bg={Color.ColdGrey_900}
      color={Color.White}
      justifyContent={JustifyContent.SpaceBetween}
    >
      <Box display={Display.Flex} alignItems={AlignItems.Center} gap={2}>
        <Thumbnail
          alt={recipe.name}
          src={getDefaultImage(image)}
          srcSet={getSrcSet(image)}
          loading="lazy"
        />
        <Text size={2} fontWeight={FontWeight.Bold}>
          Removed from basket
        </Text>
      </Box>
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        gap={2}
        role="button"
        tabIndex={0}
        onClick={onUndo}
        onKeyDown={(event) => event.key === 'Enter' && onUndo()}
        style={{ cursor: 'pointer' }}
        color={Color.Secondary_200}
      >
        <Icon name="redo" variant={IconVariant.Inherit} style={{ transform: 'scaleX(-1)' }} />
        <Text size={3} color={Color.Secondary_200} fontWeight={FontWeight.Bold}>
          Undo
        </Text>
      </Box>
    </Box>
  )
}
